(function () {
  function initGallery(root) {
    if (root.dataset.cwmgReady) return;
    var track = root.querySelector('[data-cwmg-track]');
    var thumbsTrack = root.querySelector('[data-cwmg-thumbs]');
    var allSlides = Array.prototype.slice.call(root.querySelectorAll('[data-cwmg-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cwmg-thumb]'));
    var prevBtn = root.querySelector('[data-cwmg-prev]');
    var nextBtn = root.querySelector('[data-cwmg-next]');
    if (!track || !allSlides.length) return;
    root.dataset.cwmgReady = '1';
    var section = root.closest('product-info') || root.closest('.shopify-section');
    var slides = allSlides.slice();
    var activeIndex = 0;
    var selectedPack = null;
    var packSlides = {};
    var syncTimer = null;
    allSlides.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      var match = img && (img.getAttribute('alt') || '').trim().match(/^pack:\s*(1|2|4)$/i);
      if (!match) return;
      slide.dataset.cwmgPack = match[1];
      packSlides[match[1]] = slide;
      if (thumbs[i]) {
        thumbs[i].hidden = true;
        thumbs[i].style.setProperty('display', 'none', 'important');
      }
    });
    var hasPackImages = Object.keys(packSlides).length > 0;
    function thumbForSlide(slide) {
      return thumbs[allSlides.indexOf(slide)];
    }
    function ensureThumbVisible(index) {
      var thumb = thumbForSlide(slides[index]);
      if (!thumbsTrack || !thumb || thumb.hidden) return;
      var trackLeft = thumbsTrack.scrollLeft;
      var trackRight = trackLeft + thumbsTrack.clientWidth;
      var thumbLeft = thumb.offsetLeft;
      var thumbRight = thumbLeft + thumb.offsetWidth;
      if (thumbLeft < trackLeft) {
        thumbsTrack.scrollTo({ left: thumbLeft, behavior: 'smooth' });
      } else if (thumbRight > trackRight) {
        thumbsTrack.scrollTo({ left: thumbRight - thumbsTrack.clientWidth, behavior: 'smooth' });
      }
    }
    function setActive(index) {
      activeIndex = index;
      var activeThumb = thumbForSlide(slides[index]);
      thumbs.forEach(function (thumb) {
        var active = thumb === activeThumb && !thumb.hidden;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      ensureThumbVisible(index);
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;
    }
    function slideLeft(slide) {
      return track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left - track.clientLeft;
    }
    function scrollToIndex(index, smooth) {
      if (index < 0 || index >= slides.length) return;
      setActive(index);
      track.scrollTo({
        left: slideLeft(slides[index]),
        behavior: smooth === false ? 'instant' : 'smooth'
      });
    }
    function showPack(pack) {
      if (!packSlides[pack]) return;
      selectedPack = String(pack);
      clearTimeout(syncTimer);
      allSlides.forEach(function (slide) {
        if (!slide.dataset.cwmgPack) return;
        var hidden = slide.dataset.cwmgPack !== selectedPack;
        slide.hidden = hidden;
        if (hidden) {
          slide.style.setProperty('display', 'none', 'important');
        } else {
          slide.style.removeProperty('display');
        }
      });
      slides = allSlides.filter(function (slide) { return !slide.hidden; });
      scrollToIndex(slides.indexOf(packSlides[pack]), false);
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        if (thumb.hidden) return;
        var index = slides.indexOf(allSlides[i]);
        if (index !== -1) scrollToIndex(index);
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      scrollToIndex(activeIndex - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      scrollToIndex(activeIndex + 1);
    });
    function closestIndex() {
      var center = track.getBoundingClientRect().left + track.clientLeft + track.clientWidth / 2;
      var closest = 0;
      var distance = Infinity;
      slides.forEach(function (slide, i) {
        var rect = slide.getBoundingClientRect();
        var current = Math.abs(rect.left + rect.width / 2 - center);
        if (current < distance) {
          distance = current;
          closest = i;
        }
      });
      return closest;
    }
    track.addEventListener('scroll', function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        setActive(closestIndex());
      }, 80);
    }, { passive: true });
    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var moved = false;
    function onPointerDown(event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      isDown = true;
      moved = false;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      if (track.setPointerCapture) track.setPointerCapture(event.pointerId);
    }
    function onPointerMove(event) {
      if (!isDown) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      track.scrollLeft = startScrollLeft - delta;
    }
    function onPointerUp() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      scrollToIndex(closestIndex());
      if (moved) {
        var suppressClick = function (event) {
          event.stopPropagation();
          event.preventDefault();
        };
        track.addEventListener('click', suppressClick, { capture: true, once: true });
        setTimeout(function () {
          track.removeEventListener('click', suppressClick, true);
        }, 0);
      }
    }
    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('pointerleave', onPointerUp);
    window.addEventListener('resize', function () {
      if (root.isConnected) scrollToIndex(activeIndex, false);
    });
    if (hasPackImages && section) {
      var packSelector = '.cwgo__pack[data-pack]';
      function syncSelectedPack() {
        var selected = section.querySelector(packSelector + '[aria-checked="true"]');
        if (!selected) return;
        var pack = selected.dataset.pack;
        if (packSlides[pack] && pack !== selectedPack) showPack(pack);
      }
      section.addEventListener('click', function (event) {
        var card = event.target.closest(packSelector);
        if (card && section.contains(card) && !card.disabled) showPack(card.dataset.pack);
      });
      var observer = new MutationObserver(syncSelectedPack);
      observer.observe(section, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-checked']
      });
      showPack(packSlides['2'] ? '2' : Object.keys(packSlides)[0]);
    } else {
      setActive(0);
    }
  }
  function init(scope) {
    if (scope.matches && scope.matches('[data-cwmg]')) initGallery(scope);
    scope.querySelectorAll('[data-cwmg]').forEach(initGallery);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();